__turbopack_context__.v({
  "mapContainer": "OutletDetailsMetaData-module-scss-module__uqG40q__mapContainer",
  "mapWrapper": "OutletDetailsMetaData-module-scss-module__uqG40q__mapWrapper",
  "orderFormat": "OutletDetailsMetaData-module-scss-module__uqG40q__orderFormat",
  "orderFormats": "OutletDetailsMetaData-module-scss-module__uqG40q__orderFormats",
  "outletMetaContainer": "OutletDetailsMetaData-module-scss-module__uqG40q__outletMetaContainer",
});
